import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  EventEmitter,
  ViewChild,
  Input,
} from "@angular/core";

import { ModalDirective } from "ngx-bootstrap/modal";

import { Subscription } from "rxjs";

import { CompanyEntityComponent } from "./../company-entity/company-entity.component";

import {
  AuthorizationService,
  ToastrService,
  MinesiteService,
  ModelService,
  EquipmentService,
  PoweredByService,
  ClassificationService,
  Model,
  Classification,
  PoweredBy,
  Equipment,
} from "./../../../../shared/index";

@Component({
  selector: "equipment-filter",
  templateUrl: "./equipment-filter.html",
  standalone: false,
})
export class EquipmentFilterComponent implements OnInit, OnDestroy {
  @ViewChild("equipmentFilter") filter: ModalDirective;
  @Input() live = true;

  private subscriptions: Subscription[] = [];

  public models: Model[] = [];
  public poweredBys: PoweredBy[] = [];
  public classifications: Classification[] = [];

  public selectedModels: number[] = [];
  public selectedPoweredBys: number[] = [];
  public selectedClassifications: number[] = [];

  public filterApplied = false;
  public activeEquipment = true;
  public inActiveEquipment = true;
  public serial = "";

  constructor(
    private _ngZone: NgZone,
    private _equipmenService: EquipmentService,
    private _minesiteService: MinesiteService,
    private _modelService: ModelService,
    private _poweredByService: PoweredByService,
    private _classificationService: ClassificationService,
    private _toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this._modelService.modelChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.models = info;
        });
      })
    );
    this.subscriptions.push(
      this._poweredByService.poweredByChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.poweredBys = info;
        });
      })
    );
    this.subscriptions.push(
      this._classificationService.classificationChange.subscribe(
        (info: any) => {
          this._ngZone.run(() => {
            this.classifications = info;
          });
        }
      )
    );

    if (this.live) {
      this._modelService.getModelsConstraint();
      this._poweredByService.getPoweredBys();
      this._classificationService.getClassifications();
    } else {
      this._modelService.getModelsConstraintStaged();
      this._poweredByService.getPoweredBysStaged();
      this._classificationService.getClassificationsStaged();
    }
  }
  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  public showFilters(): void {
    this.filter.show();
  }

  public applyFilter(): void {
    if (
      this.serial != "" ||
      this.activeEquipment == false ||
      this.inActiveEquipment == false ||
      this.selectedModels.length > 0 ||
      this.selectedPoweredBys.length > 0 ||
      this.selectedClassifications.length > 0
    ) {
      this.filterApplied = true;
      this._poweredByService.setFilter(
        this.serial,
        this.activeEquipment,
        this.inActiveEquipment,
        this.selectedPoweredBys
      );
      this._equipmenService.setFilter(
        this.serial,
        this.activeEquipment,
        this.inActiveEquipment
      );
    } else {
      this.filterApplied = false;
      this._poweredByService.clearFilter();
      this._equipmenService.clearFilter();
    }
    this._modelService.applyFilter(
      this.serial,
      this.activeEquipment,
      this.inActiveEquipment,
      this.live,
      this.selectedModels,
      this.selectedPoweredBys,
      this.selectedClassifications
    );
    this.filter.hide();
  }

  public close(): void {
    this.filter.hide();
  }

  public clearFilter(): void {
    this._poweredByService.clearFilter();
    this.serial = "";
    this.activeEquipment = true;
    this.inActiveEquipment = true;
    this.selectedModels = [];
    this.selectedPoweredBys = [];
    this.selectedClassifications = [];
    this.filterApplied = false;
  }
}
